import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { VentaDiaria } from '../../inicio.service';
import { colorBarra, customizeTooltip } from '../../shared/format';
import { exportarElemento } from '../../shared/export';
import { rangoDias } from '../../shared/metrics';

@Component({
  selector: 'app-ventas-diarias-chart',
  templateUrl: './ventas-diarias-chart.component.html',
  styleUrls: ['./ventas-diarias-chart.component.scss']
})
export class VentasDiariasChartComponent implements OnChanges {
  @Input() ventasDiarias: VentaDiaria[] = [];
  @Input() ventasAnterior: VentaDiaria[] = [];
  @Input() desde!: Date;
  @Input() hasta!: Date;
  @ViewChild('exportRef') exportRef!: ElementRef;

  // Solo el rango seleccionado. La data extra (doble rango) es solo para comparar.
  ventasRango: VentaDiaria[] = [];

  customizeTooltip = customizeTooltip;

  ngOnChanges() {
    if (!this.desde || !this.hasta) {
      this.ventasRango = this.ventasDiarias;
      return;
    }
    this.ventasRango = this.ventasDiarias.filter(v => {
      const d = new Date(v.fecha);
      return d >= this.desde && d <= this.hasta;
    });
  }

  exportar(tipo: 'png' | 'pdf') {
    exportarElemento(this.exportRef.nativeElement, tipo, 'ventas-diarias', ['.export-actions']);
  }

  customizePoint = (arg: any): any => {
    const campo = arg.seriesName === 'Kg' ? 'totalKg' : 'totalPesos';
    const offset = this.desde && this.hasta ? rangoDias(this.desde, this.hasta) : 28;
    const fecha = new Date(arg.argument);
    const fechaAnterior = new Date(fecha);
    fechaAnterior.setDate(fechaAnterior.getDate() - offset);
    // El dia equivalente del periodo anterior vive en `ventasAnterior`.
    const anterior = this.ventasAnterior.find(v => {
      const d = new Date(v.fecha);
      return d.getFullYear() === fechaAnterior.getFullYear()
          && d.getMonth() === fechaAnterior.getMonth()
          && d.getDate() === fechaAnterior.getDate();
    });
    const actualVal = this.ventasDiarias.find(v => new Date(v.fecha).toDateString() === fecha.toDateString())?.[campo] ?? 0;
    const anteriorVal = anterior ? anterior[campo] : null;
    const positivo = anteriorVal === null || anteriorVal === 0 || actualVal >= anteriorVal;
    return { color: colorBarra(positivo, arg.seriesName === 'Kg') };
  };
}
